import { useContext } from 'react';

import { NotificationsContext } from '..';

export const useNotificationsContext = () => useContext(NotificationsContext);
